import { getFreshAuthToken } from "./auth-session";
import { Request } from "./request";

export { Request, RequestError } from "./request";
export default new Request({
  baseUrl: import.meta.env.REACT_APP_API_URL ?? "",
  getAccessToken: getFreshAuthToken,
  onError: (error) => {
    if (
      error.status === 403 &&
      error.code === "SETUP_REQUIRED" &&
      window.location.pathname.replace(/\/+$/, "") !== "/account-setup"
    ) {
      window.location.replace("/account-setup");
    }
  },
});
